import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomButton from "./CustomButton";
import axiosInstance from "../utils/axiosInstance";
import { toast } from "react-toastify";
import { rmValidationSchema } from "../utils/validationSchemas";
import { debounce } from "lodash";
import { useCallback } from "react";

export const RM = ({ phoneNumber }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
  const [rmError, setRmError] = useState(false);
  const [rmValue, setRmValue] = useState({
    rmCode: "",
    rmName: "",
    rmEmail: "",
  });

  const { redirectTo } = location?.state || {};

  const [formData, setFormData] = useState({
    hasRM: false, // Set "No" as default by setting false
    rmCode: "",
  });
  const [errors, setErrors] = useState({});

  const validateRmCode = async (newPartnerCode) => {
    try {
      const resp = await rmValidationSchema.validate(
        { rm: newPartnerCode },
        { abortEarly: false }
      );
      // setApiError("");
      return true;
    } catch (err) {
      console.log("ERROR in RM===========>>>>>>>>>", err, err.message);
      setApiError(err.message);
      setRmError(false);
      return false;
    }
  };

  const handlePartnerCodeChange = async (event) => {
    const newPartnerCode = event.target.value;

    if (!/^\d{0,6}$/.test(newPartnerCode)) {
      // setRmError(false);
      return;
    }

    setRmValue((prev) => ({
      ...prev,
      rmCode: newPartnerCode,
      rmName: "",
    }));
    setApiError("");
    setRmError(false);

    if (newPartnerCode === "150852") {
      setRmValue((prev) => ({
        ...prev,
        rmName: "Yamini  Singh",
      }));
      setRmError(true);
      return;
    }

    debouncedVerifyRM(newPartnerCode, phoneNumber);
  };

  const debouncedVerifyRM = useCallback(
    debounce(async (code, phone) => {
      if (code.length >= 5) {
        setLoading(true);
        try {
          const response = await axiosInstance.post("/augmont/verifyRM", {
            RMCode: code,
            phone: phone || "",
          });

          const { RMName, RMEmail } = response.data?.data?.[0];

          if (response?.data?.error || !RMName) {
            setApiError("Invalid RM code. Please check and try again.");
            setRmError(false);
          } else {
            setRmValue((prev) => ({
              ...prev,
              rmName: RMName,
              rmEmail: RMEmail,
            }));
            setRmError(true);
            setApiError("");
          }
        } catch (error) {
          console.error("API call failed:", error);
          setApiError("Invalid RM code. Please check and try again.");
          setRmError(false);
        } finally {
          setLoading(false);
        }
      }
    }, 500),
    []
  );

  // const verifyRm = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await axiosInstance.post("/augmont/verifyRM", {
  //       RMCode: code,
  //       phone: phone || "",
  //     });

  //     const rmName = response.data?.data?.[0]?.RMName;

  //     if (response.data.error || !rmName) {
  //       setApiError("Invalid RM code. Please check and try again.");
  //       setRmError(false);
  //     } else {
  //       setRmValue((prev) => ({
  //         ...prev,
  //         rmName,
  //       }));
  //       setRmError(true);
  //       setApiError("");
  //     }
  //   } catch (error) {
  //     console.error("API call failed:", error);
  //     setApiError("Invalid RM code. Please check and try again.");
  //     setRmError(false);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleTagRm = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.post("/augmont/TagRm", {
        RMCode: rmValue.rmCode || 168491,
        RMName: rmValue.rmName || "",
        phone: phoneNumber || "",
        RMEmail: rmValue.rmEmail || "",
      });

      if (response.data.error) {
        toast.error(response.data.message || "Something went wrong!");
      }
    } catch (error) {
      console.error("Error tagging partner:", error);
      toast.error("Failed to tag RM. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleHasRMChange = (value) => {
    setFormData({
      ...formData,
      hasRM: value,
    });
    setErrors({
      ...errors,
      hasRM: "",
    });

    if (value === false) {
      setRmValue({
        rmCode: "",
        rmName: "",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // If "No" is selected
    if (formData.hasRM === false) {
      await handleTagRm();
      navigate(redirectTo || "/account", { state: location.state });
      return;
    }

    // If "Yes" is selected but no RM code is entered
    // if (formData.hasRM === true && !rmValue.rmCode) {
    //   setErrors({
    //     ...errors,
    //     rmCode: "RM code is required",
    //   });
    //   return;
    // }

    const isValidRmCode = await validateRmCode(rmValue.rmCode);
    if (!isValidRmCode) return;

    // Validate RM code if "Yes" is selected and code is entered
    // if (formData.hasRM === true && rmValue.rmCode == "150852") {
    if (formData.hasRM === true && rmValue.rmName !== "") {
      // const isValidRmCode = await validateRmCode(rmValue.rmCode);
      // if (!isValidRmCode) return;

      try {
        await handleTagRm();
        navigate(redirectTo || "/account", { state: location.state });
      } catch (error) {
        console.error("Error in submit:", error);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", margin: "0 auto" }}>
      <div style={{ marginBottom: "1.5rem" }}>
        <label
          style={{
            display: "block",
            marginBottom: "0.5rem",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          Are you assisted by a Relationship Manager?{" "}
        </label>
        <div style={{ display: "flex", gap: "1rem", justifyContent: "center" }}>
          <button
            type="button"
            className={`rm-btn ${formData.hasRM === true ? "active" : ""}`}
            onClick={() => handleHasRMChange(true)}
          >
            Yes
          </button>
          <button
            type="button"
            className={`rm-btn ${formData.hasRM === false ? "active" : ""}`}
            onClick={() => handleHasRMChange(false)}
          >
            No
          </button>
        </div>
        {errors.hasRM && (
          <p style={{ color: "red", marginTop: "0.5rem" }}>{errors.hasRM}</p>
        )}
      </div>

      {formData.hasRM && (
        <div style={{ marginTop: "1.1rem" }}>
          <label
            htmlFor="rmCode"
            style={{
              fontWeight: "600",
              marginBottom: "8px",
              fontSize: "12px",
            }}
          >
            Enter RM Code
          </label>
          <input
            type="text"
            id="rmCode"
            name="rmCode"
            placeholder="Enter RM Code"
            className="rm_input"
            value={rmValue.rmCode}
            onChange={handlePartnerCodeChange}
          />
          {loading ? (
            <div className="rm-loading-message">Verifying...</div>
          ) : (
            (apiError || errors.rmCode) && (
              <div className="rm-error-message">
                {apiError || errors.rmCode}
              </div>
            )
          )}

          {rmError && (
            <div className="rm-success-message">
              RM Name:{" "}
              <span style={{ color: "seagreen" }}>{rmValue.rmName || ""}</span>
            </div>
          )}
        </div>
      )}

      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}
      >
        <CustomButton type="submit" label="Submit" loading={loading} />
      </div>
    </form>
  );
};
